export const getUserToken = () => {
    return localStorage.getItem('aitoken');
}

export const getUserName = () => {
    return localStorage.getItem('name');
}

export const setUserToken = (token) => {
  return localStorage.setItem('aitoken', token);
}

export const setUserName = (name) => {
  return localStorage.setItem('name', name);
}

export const removeUserInfo = () => {
  localStorage.removeItem('aitoken')
  localStorage.removeItem('name')
}


// WEBPACK FOOTER //
// ./src/utils/user.js